export default "__VITE_ASSET__DHk1Xv2n__"